import { Adjustment, AdjustmentService } from './../../acumatica/EntityServices/Adjustment.service';
import { StockItemService } from '../../acumatica/EntityServices/StockItem.service';
import { PrinterSelectDialog } from '../../common/printer-selector/printer-selector.component';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationScreen } from '../../application-navigator/application-screen';
import { AcumaticaService } from '../../acumatica/acumatica.service';
import { WarehouseLocationInventoryInquiry as WarehouseLocationInventoryInquiry, WarehouseLocationInventoryInquiryService } from '../../acumatica/EntityServices/WarehouseLocationInventoryInquiry.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { StockItem } from '../../acumatica/EntityServices/StockItem.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { WarehouseSelectorComponent } from '../../common/warehouse-selector/warehouse-selector.component';
import { WMSService } from '../../services/wms.service';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { AdjustmentDetail } from 'src/app/acumatica/EntityServices/Adjustment.service';
import { ConfirmationDialog } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-location-inquiry',
  templateUrl: './location-inquiry.component.html',
  styleUrls: ['./location-inquiry.component.css'],
  viewProviders: [MatExpansionPanel]
})
export class LocationInquiryComponent extends ApplicationScreen implements OnInit, AfterViewInit {
  @ViewChild('warehouseIDField') warehouseIDField?: WarehouseSelectorComponent;
  @ViewChild('locationIDField') locationIDField?: ElementRef;
  lotQtyColumns = ['LotSerialNbr', 'QtyAvailable', 'menu'];
  pageTitle: string = "Location Inquiry";

  constructor(
    private changeDetector: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private acumatica: AcumaticaService,
    private inquirySerivce: WarehouseLocationInventoryInquiryService,
    private wms: WMSService,
    private adjustments: AdjustmentService
  ) {
    super();
  }

  screenMenuItems = [
    {
      label: 'Print Location / Bin Label', handler: () => {
        if (!this.locationID) {
          this.dialog.open(AlertDialog, { data: { message: "Enter the Bin / Location ID" } });
          return;
        }

        this.dialog.open(PrinterSelectDialog).afterClosed().subscribe(result => {
          if (!result?.Printer) return;

          this.wms.printBinLocationTag(result.Printer.id, this.locationID!).subscribe();
        })
      }
    },
  ]

  private _warehouseID: string | null = null;
  get warehouseID(): string | null { return this._warehouseID; }
  set warehouseID(value: string | null) {
    // if the value hasn't changed return
    if (this._warehouseID === value) return;
    // create a nav path array..
    let nav = ['/location', value];
    // ..that includes the Location if one is specified
    if (this.locationID) nav.push(this.locationID);
    // navigate to it, replaceUrl (overrite previous history nav path) when there was no warehouse previously
    if (value) this.router.navigate(nav, { replaceUrl: !this._warehouseID });
    // save the new warehouse member value
    this._warehouseID = value;
    // focus location field
    this.locationIDField?.nativeElement.focus();
  }

  @Input() locationID: string | null = null;
  @Output() locationIDChange = new EventEmitter<string | null>();

  ngOnInit(): void {
    this.route.paramMap
      .subscribe(params => {
        let locationID = params.get('locationID');
        if (locationID) this.locationID = locationID;
        let warehouseID = params.get('warehouseID');
        if (warehouseID) this.warehouseID = warehouseID;
        this.loadLocationContent();
      });
  }

  ngAfterViewInit(): void {
    if (!this.warehouseID)
      this.warehouseIDField?.focus();
    else if (!this.locationID)
      this.locationIDField?.nativeElement.focus();

    this.changeDetector.detectChanges();
  }

  items: LocationItem[] = [];
  dataFetched: boolean = false;
  selectLocation() {
    this.router.navigate(['/location', this.warehouseID, this.locationID]);
  }

  loadLocationContent() {
    if (!this.warehouseID || !this.locationID) return;

    this.dataFetched = false;
    this.items = [];

    this.inquirySerivce.get(new WarehouseLocationInventoryInquiry({
      WarehouseID: this.warehouseID,
      LocationID: this.locationID,
    }), {
      loader: { message: "Getting Location contents" }
    }).subscribe(response => {
      if (response.Details)
        console.warn(response);
      this.items = response.Details.group<LocationItem>({
        by: ['InventoryID', 'ItemClassID', 'Description', 'LotSerialClass'],
        sum: ['QtyAvailable', 'QtyOnHand']
      }, 'Lots', ['LotSerialNbr', 'LotSerialHash', 'QtyAvailable', 'QtyOnHand'])
        .map((item: LocationItem) => {
          item.LotsTable = new MatTableDataSource(item.Lots);
          return Object.assign(new LocationItem(), item);
        });

      this.dataFetched = true;
    });
  }

  printStockTag(item: LocationItem, lot: LotDetail) {
    this.dialog.open(PrinterSelectDialog)
      .afterClosed().subscribe((result: any) => {
        if (!result?.Printer) return;
        this.wms.printStockRollTag(result.Printer.id, item.InventoryID, lot.LotSerialNbr || '', lot.QtyAvailable!).subscribe();
      });
  }

  inventoryAdjustment(item: LocationItem, lot: LotDetail) {
    let adjustment = new AdjustmentDetail();
    adjustment.InventoryID = item.InventoryID;
    adjustment.LotSerialNbr = lot.LotSerialNbr || null;
    adjustment.LocationID = this.locationID;
    adjustment.WarehouseID = this.warehouseID;
    adjustment.Quantity = lot.QtyAvailable || 0;

    this.acumatica.editInventoryAdjustment(adjustment).then(adjustment => {
      if (adjustment === undefined) return;

      let confirmPrompt = "Confirm adjustment\n" +
        "Item: " + item.InventoryID + "\n" + item.Description + "\n" +
        "System Qty: " + ((adjustment.AdjustQtyTo || 0) - adjustment.Quantity) + "\n" +
        "Corrected Qty: " + adjustment.AdjustQtyTo + "\n" +
        "Adjustment: " + adjustment.Quantity;

      this.dialog.open(ConfirmationDialog, {
        data: {
          message: confirmPrompt
        }
      }).afterClosed().subscribe(resp => {
        if (!resp) return;

        let adjustmentDoc = new Adjustment();
        adjustmentDoc.Description = "Location Piece " + item.InventoryID + " / " + adjustment.LotSerialNbr;
        adjustmentDoc.Details.push(adjustment);
        this.adjustments.put(adjustmentDoc).subscribe(postedAdjustment => {
          this.adjustments.Release(postedAdjustment).subscribe(() => {

            this.dialog.open(PrinterSelectDialog)
              .afterClosed().subscribe((result: any) => {
                if (!result?.Printer) return;
                this.wms.printStockRollTag(result.Printer.id, item.InventoryID, adjustment.LotSerialNbr || '', adjustment.AdjustQtyTo!).subscribe();
              });

          })
        })
      });
    })
  }
}

interface LotDetail {
  LotSerialHash?: string;
  LotSerialNbr?: string;
  QtyOnHand?: number;
  QtyAvailable?: number;
}
class LocationItem extends StockItem {
  Lots?: LotDetail[];
  LotsTable?: MatTableDataSource<LotDetail>
}